import styles from "./Specifications.module.scss";
import MediaQuery from "react-responsive";
import { useState, useRef } from "react";
import { Reorder } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Controller } from "swiper/modules";
import Heading from "../Typography/Heading/Heading";
import Text from "../Typography/Text/Text";
import CCS_Combo_2 from "../../static/images/CCS_Combo_2.png";
import CHAdeMO from "../../static/images/CHAdeMO.png";
import GB_Т from "../../static/images/GB_Т.png";
import Type_2 from "../../static/images/Type_2.png";

export default function Specifications() {
  const [ccsComboAstive, setCcsComboActive] = useState(true);
  const [chademoActive, setChademoActive] = useState(false);
  const [gbtActive, setGbtActive] = useState(false);
  const [type2Active, setType2Active] = useState(false);
  const [list, setList] = useState(["CHAdeMO", "GB/Т", "Type 2"]);
  const [activeValues, setActiveValues] = useState(false);
  const [paginationTopClassActive, setPaginationTopClassActive] = useState(0);
  const [swiper, setSwiper] = useState(undefined);

  const swiperContent = [
    {
      chargingSystem: "CCS Combo 2",
      image: CCS_Combo_2,
      maxPowerValue: "120",
      maxCurrentValue: "200",
      voltRange: "200-1000",
    },
    {
      chargingSystem: "CHAdeMO",
      image: CHAdeMO,
      maxPowerValue: "90",
      maxCurrentValue: "200",
      voltRange: "200-1000",
    },
    {
      chargingSystem: "GB/Т",
      image: GB_Т,
      maxPowerValue: "120",
      maxCurrentValue: "200",
      voltRange: "200-1000",
    },
    {
      chargingSystem: "Type 2",
      image: Type_2,
      maxPowerValue: "22",
      maxCurrentValue: "32",
      voltRange: "200-380",
    },
  ];

  const maximumPower = useRef(null);
  const maximumCurrent = useRef(null);
  const voltageRange = useRef(null);

  function render(e, idx) {
    setDeviceList(e.target.innerHTML, idx);
    let innerHTML = e.target.innerHTML;
    setCcsComboActive(false);
    setChademoActive(false);
    setGbtActive(false);
    setType2Active(false);
    setActiveValues(true);
    if (innerHTML === "CCS Combo 2") {
      setCcsComboActive(true);
      // setList(["CHAdeMO", "GB/Т", "Type 2"]);
      setTimeout(() => {
        changeValues(innerHTML);
      }, 350);
    } else if (innerHTML === "CHAdeMO") {
      setChademoActive(true);
      // setList(["CCS Combo 2", "GB/Т", "Type 2"]);
      setTimeout(() => {
        changeValues(innerHTML);
      }, 350);
    } else if (innerHTML === "GB/Т") {
      setGbtActive(true);
      // setList(["CCS Combo 2", "CHAdeMO", "Type 2"]);
      setTimeout(() => {
        changeValues(innerHTML);
      }, 350);
    } else if (innerHTML === "Type 2") {
      setType2Active(true);
      // setList(["CCS Combo 2", "CHAdeMO", "GB/Т"]);
      setTimeout(() => {
        changeValues(innerHTML);
      }, 350);
    }
    setTimeout(() => {
      setActiveValues(false);
    }, 700);
  }

  function setDeviceList(selectedDevice, id) {
    let previousDevice = "";
    let newDeviceList = [];
    if (ccsComboAstive) {
      previousDevice = "CCS Combo 2";
    } else if (chademoActive) {
      previousDevice = "CHAdeMO";
    } else if (gbtActive) {
      previousDevice = "GB/Т";
    } else if (type2Active) {
      previousDevice = "Type 2";
    }
    if (id + 1 > list.length / 2) {
      list.unshift(previousDevice);
    } else {
      list.push(previousDevice);
    }
    newDeviceList = list.filter((el) => el !== selectedDevice);
    setList(...[newDeviceList]);
  }

  function changeValues(innerHTML) {
    if (innerHTML === "CCS Combo 2") {
      maximumPower.current.children[0].innerHTML = 120;
      maximumCurrent.current.children[0].innerHTML = 200;
      voltageRange.current.children[0].innerHTML = "200–1000";
      // voltageRange.current.style.width = `${voltageRange.current.scrollWidth}px`;
    } else if (innerHTML === "CHAdeMO") {
      maximumPower.current.children[0].innerHTML = 90;
      maximumCurrent.current.children[0].innerHTML = 200;
      voltageRange.current.children[0].innerHTML = "200–1000";
    } else if (innerHTML === "GB/Т") {
      maximumPower.current.children[0].innerHTML = 120;
      maximumCurrent.current.children[0].innerHTML = 200;
      voltageRange.current.children[0].innerHTML = "200–1000";
    } else if (innerHTML === "Type 2") {
      maximumPower.current.children[0].innerHTML = 22;
      maximumCurrent.current.children[0].innerHTML = 32;
      voltageRange.current.children[0].innerHTML = "200–380";
    }
  }

  function paginationTopController(idx) {
    swiper.slideTo(idx);
    setPaginationTopClassActive(idx);
  }

  return (
    <div id="Specifications" className={styles.specifications}>
      <div className={`${styles.container} container`}>
        <div className={styles.title}>
          <Heading level="h3" fw={600}>
            Технические характеристики
          </Heading>
        </div>
        <div className={styles.contentWrap}>
          <MediaQuery minWidth={1366}>
            <div className={styles.content}>
              <div
                className={
                  ccsComboAstive
                    ? `${styles.image} ${styles.active}`
                    : `${styles.image}`
                }
              >
                <img src={CCS_Combo_2} alt="" />
              </div>
              <div
                className={
                  chademoActive
                    ? `${styles.image} ${styles.active}`
                    : `${styles.image}`
                }
              >
                <img src={CHAdeMO} alt="" />
              </div>
              <div
                className={
                  gbtActive
                    ? `${styles.image} ${styles.active}`
                    : `${styles.image}`
                }
              >
                <img src={GB_Т} alt="" />
              </div>
              <div
                className={
                  type2Active
                    ? `${styles.image} ${styles.active}`
                    : `${styles.image}`
                }
              >
                <img src={Type_2} alt="" />
              </div>
              <div className={styles.deviceList}>
                <Reorder.Group axis="y" values={list}>
                  {list.map((item, idx) => (
                    <Reorder.Item
                      key={item}
                      dragListener={false}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.7 }}
                    >
                      <div
                        className={styles.device}
                        onClick={(e) => {
                          render(e, idx);
                        }}
                      >
                        <Heading level="h5" fw={500}>
                          {item}
                        </Heading>
                      </div>
                    </Reorder.Item>
                  ))}
                </Reorder.Group>
              </div>
              <div className={styles.currentDevice}>
                <div
                  className={
                    ccsComboAstive
                      ? `${styles.currentDevice__item} ${styles.active}`
                      : `${styles.currentDevice__item}`
                  }
                >
                  CCS Combo 2
                </div>
                <div
                  className={
                    chademoActive
                      ? `${styles.currentDevice__item} ${styles.active}`
                      : `${styles.currentDevice__item}`
                  }
                >
                  CHAdeMO
                </div>
                <div
                  className={
                    gbtActive
                      ? `${styles.currentDevice__item} ${styles.active}`
                      : `${styles.currentDevice__item}`
                  }
                >
                  GB/Т
                </div>
                <div
                  className={
                    type2Active
                      ? `${styles.currentDevice__item} ${styles.active}`
                      : `${styles.currentDevice__item}`
                  }
                >
                  Type 2
                </div>
              </div>
              <div className={styles.info}>
                <div className={styles.info__item}>
                  <div
                    ref={maximumPower}
                    className={
                      activeValues
                        ? `${styles.value} ${styles.active}`
                        : `${styles.value}`
                    }
                  >
                    <Heading level="h4">120</Heading>
                  </div>
                  <div className={styles.units}>
                    <Heading level="h4">кВт</Heading>
                  </div>
                  <div className={styles.description}>
                    <Text size="large" fw={500}>
                      максимальная
                      <br />
                      выходная мощность
                    </Text>
                  </div>
                </div>
                <div className={styles.info__item}>
                  <div
                    ref={maximumCurrent}
                    className={
                      activeValues
                        ? `${styles.value} ${styles.active}`
                        : `${styles.value}`
                    }
                  >
                    <Heading level="h4">200</Heading>
                  </div>
                  <div className={styles.units}>
                    <Heading level="h4">А</Heading>
                  </div>
                  <div className={styles.description}>
                    <Text size="large" fw={500}>
                      максимальный <br />
                      ток на выходе
                    </Text>
                  </div>
                </div>
                <div className={styles.info__item}>
                  <div
                    ref={voltageRange}
                    className={
                      activeValues
                        ? `${styles.value} ${styles.active}`
                        : `${styles.value}`
                    }
                  >
                    <Heading level="h4">200–1000</Heading>
                  </div>
                  <div className={styles.units}>
                    <Heading level="h4"> В</Heading>
                  </div>
                  <div className={styles.description}>
                    <Text size="large" fw={500}>
                      диапазон <br />
                      выходного напряжения
                    </Text>
                  </div>
                </div>
                <div className={styles.info__item}>
                  <div className={styles.value}>
                    <Heading level="h4"> 5–8м</Heading>
                  </div>
                  <div className={styles.description}>
                    <Text size="large" fw={500}>
                      средняя <br />
                      длина кабеля
                    </Text>
                  </div>
                </div>
              </div>
            </div>
          </MediaQuery>
          <MediaQuery maxWidth={1365}>
            <div className={styles.pagination__top}>
              {swiperContent.map((item, idx) => (
                <div
                  key={idx}
                  className={
                    paginationTopClassActive === idx
                      ? `${styles.pagination__top__item} ${styles.active}`
                      : `${styles.pagination__top__item}`
                  }
                  onClick={() => paginationTopController(idx)}
                >
                  <Text size="large">{item.chargingSystem}</Text>
                </div>
              ))}
            </div>
            <Swiper
              className="specificationsSwiper"
              onSlideChange={(e) => setPaginationTopClassActive(e.activeIndex)}
              onSwiper={setSwiper}
              slidesPerView={1}
              spaceBetween={16}
              speed={300}
              centeredSlides={true}
              modules={[Navigation, Pagination, Controller]}
              pagination={{
                type: "bullets",
                clickable: true,
                el: ".paginations-bottom",
              }}
            >
              {swiperContent.map((item, idx) => (
                <SwiperSlide key={idx}>
                  <div className={styles.content}>
                    <div className={styles.image}>
                      <img src={item.image} alt="" />
                    </div>
                    <div className={styles.info}>
                      <div className={styles.info__item}>
                        <div className={styles.value}>
                          <Text size="large">{item.maxPowerValue} кВт</Text>
                        </div>
                        <div className={styles.description}>
                          <Text size="small">
                            максимальная
                            <br />
                            выходная мощность
                          </Text>
                        </div>
                      </div>
                      <div className={styles.info__item}>
                        <div className={styles.value}>
                          <Text size="large">{item.maxCurrentValue} А</Text>
                        </div>
                        <div className={styles.description}>
                          <Text size="small">
                            максимальный <br />
                            ток на выходе
                          </Text>
                        </div>
                      </div>
                      <div className={styles.info__item}>
                        <div className={styles.value}>
                          <Text size="large">{item.voltRange} В</Text>
                        </div>
                        <div className={styles.description}>
                          <Text size="small">
                            диапазон <br />
                            выходного напряжения
                          </Text>
                        </div>
                      </div>
                      <div className={styles.info__item}>
                        <div className={styles.value}>
                          <Text size="large">5–8м</Text>
                        </div>
                        <div className={styles.description}>
                          <Text size="small">
                            средняя <br />
                            длина кабеля
                          </Text>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="paginations-bottom" />
          </MediaQuery>
        </div>
      </div>
    </div>
  );
}
